"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
/**
 * The four air inputs every coil takes, in express mode.
 *
 * A steam express run can sweep the inlet temperature or the inlet humidity, and while it does
 * the single value it replaces has nothing to say. Which run that is belongs to the steam side,
 * not here, so the composer hands in when to hide each one; a coil type that sweeps neither
 * passes an empty filter and both stay visible.
 */
function propertyDefinition(pvs, hideTemperatureWhen = property_1.PropertyFilter.Empty, hideHumidityWhen = property_1.PropertyFilter.Empty) {
    const humidityConversion = {
        pressure: property_1.PropertyValueSet.getAmount("airinputspressure", pvs),
        temperature: property_1.PropertyValueSet.getAmount("airinputstemperature", pvs)
    };
    return [
        {
            sort_no: 10,
            name: "airinputstemperature",
            group: "",
            quantity: "Temperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: hideTemperatureWhen,
            value: []
        },
        {
            sort_no: 20,
            name: "airinputshumidity",
            group: "",
            quantity: "RelativeHumidity",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: hideHumidityWhen,
            value: [],
            conversionParameters: humidityConversion
        },
        {
            sort_no: 30,
            name: "airinputspressure",
            group: "",
            quantity: "Pressure",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 40,
            name: "airinputsairflow",
            group: "",
            quantity: "MassFlow",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        }
    ];
}
//# sourceMappingURL=express-airinputs-definition.js.map